/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ManagerResource } from './';
import {
    ManagerResourceFromJSON,
    ManagerResourceFromJSONTyped,
    ManagerResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ManagersResource
 */
export interface ManagersResource {
    /**
     * 
     * @type {ManagerResource}
     * @memberof ManagersResource
     */
    company?: ManagerResource;
    /**
     * 
     * @type {ManagerResource}
     * @memberof ManagersResource
     */
    finOps?: ManagerResource;
    /**
     * 
     * @type {ManagerResource}
     * @memberof ManagersResource
     */
    customerSuccess?: ManagerResource;
}

/**
 * Check if a given object implements the ManagersResource interface.
 */
export function instanceOfManagersResource(value: object): value is ManagersResource {
    return true;
}

export function ManagersResourceFromJSON(json: any): ManagersResource {
    return ManagersResourceFromJSONTyped(json, false);
}

export function ManagersResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagersResource {
    if (json == null) {
        return json;
    }
    return {
        
        'company': json['company'] == null ? undefined : ManagerResourceFromJSON(json['company']),
        'finOps': json['finOps'] == null ? undefined : ManagerResourceFromJSON(json['finOps']),
        'customerSuccess': json['customerSuccess'] == null ? undefined : ManagerResourceFromJSON(json['customerSuccess']),
    };
}

export function ManagersResourceToJSON(value?: ManagersResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'company': ManagerResourceToJSON(value['company']),
        'finOps': ManagerResourceToJSON(value['finOps']),
        'customerSuccess': ManagerResourceToJSON(value['customerSuccess']),
    };
}

